/*
 * ${{FOO.BAR}} is not a JS template string.
 *
 * !!!!!!
 * It is replaced by entrypoint.sh during CI rollout.
 * Make sure entrypoint.sh has the exact same entries defined!!!
 */

export const isLocalDev = __DEV__ || process.env.NODE_ENV === 'test';
export const ENV: string = isLocalDev ? 'local' : '${{DD.ENV}}';

// eslint-disable-next-line no-console
console.log('Environment:', ENV);

// Root Domains
// These should always be strings.
export const API_ROOT = isLocalDev ? '/api' : '${{API.ROOT}}';

// App version. version.ts is updated by the CI during packaging.
export { VERSION as APP_VERSION } from './version';

// AWS Cognito
// Defaulting to prod-owned local development pools
export const COGNITO_USER_POOL_ID = isLocalDev ? 'us-east-1_TfWUHL9lN' : '${{COGNITO.USER_POOL_ID}}';
export const COGNITO_CLIENT_ID = isLocalDev ? '51slhqpqqei1449cmjjsq24sk3' : '${{COGNITO.CLIENT_ID}}';
export const COGNITO_CC_CLIENT_ID = isLocalDev ? '7rk16ul22mthr3q48eiqvonf0q' : '${{COGNITO.CC_CLIENT_ID}}';
export const COGNITO_CC_DOMAIN = isLocalDev
    ? 'https://service-local-auth-command-center.auth.us-east-1.amazoncognito.com'
    : '${{COGNITO.CC_DOMAIN}}';

const getCognitoRedirectUri = () => {
    if (isLocalDev) {
        return 'https://command.local.internal.ndvr.com:8090/authorize';
    }

    if (typeof window !== 'undefined' && window.location.origin) {
        return `${window.location.origin}/authorize`;
    }

    return '${{COGNITO.CC_REDIRECT_URI}}';
};

export const COGNITO_CC_REDIRECT_URI = getCognitoRedirectUri();
// do not make this line a template! swcrc.minify will mangle it (with swc v1.3.38)
export const COGNITO_OAUTH_URL = encodeURI(
    COGNITO_CC_DOMAIN +
        '/oauth2/authorize?client_id=' +
        COGNITO_CC_CLIENT_ID +
        '&response_type=code&scope=aws.cognito.signin.user.admin+email+openid&redirect_uri=' +
        COGNITO_CC_REDIRECT_URI,
);
